import {
  Box,
  Button,
  Grid2,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({
  sra,
  setSra,
  setStep,
  storedUser,
  fileNames,
  setFileNames,
}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [uploadLoading, setUploadLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [strategies, setStrategies] = useState();
  const [categories, setCategories] = useState();

  useEffect(() => {
    const getStrategies = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/strategy`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setStrategies(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    const getCategories = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/category`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setCategories(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    getStrategies();
    getCategories();
  }, []);

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   const data = sra || {};

  //   const isEmpty = (value) => !value || value.trim?.() === "";

  //   const now = new Date();

  //   // const creationDate = data.creationDate ? new Date(data.creationDate) : null;
  //   const submissionDate = data.submissionDate
  //     ? new Date(data.submissionDate)
  //     : null;

  //   if (isEmpty(data.brief)) {
  //     newErrors.brief = "Long Description is required";
  //   } else if (data.brief.length > 1000) {
  //     newErrors.brief = "Long Description should be upto 1000 characters";
  //   }
  //   // if (!creationDate) {
  //   //   newErrors.creationDate = "sra Creation Date is required";
  //   // } else {
  //   //   const today = new Date();
  //   //   today.setHours(0, 0, 0, 0);
  //   //   if (creationDate < today) {
  //   //     newErrors.creationDate = "sra Creation Date cannot be in the past";
  //   //   }
  //   // }
  //   if (!submissionDate) {
  //     newErrors.submissionDate = "Quotes required by date is required";
  //   } else if (submissionDate < now) {
  //     newErrors.submissionDate =
  //       "Quotes required by date cannot be in the past";
  //   }
  //   // if (isEmpty(data.document)) newErrors.document = "Attachment is required";
  //   if (isEmpty(data.name)) newErrors.name = "Name is required";
  //   if (isEmpty(data.shortDesc)) newErrors.shortDesc = "Name is required";
  //   // if (isEmpty(data.email)) {
  //   //   newErrors.email = "Email is required";
  //   // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
  //   //   newErrors.email = "Enter a valid email address";
  //   // }
  //   if (isEmpty(data.dept)) newErrors.dept = "Department is required";

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleNext = async () => {
    // if (!validateForm()) return
    setBtnLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/draft`,
        {
          username: storedUser.username,
          title: sra.title,
          pr: sra.pr,
          strategy: sra.strategy,
          company: sra.company,
          category: sra.category,
          auction: sra.auction,
          plant: sra.plant,
          buyer: sra.buyer,
          singleApproval: sra.singleApproval,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSra(res.data);
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdate = async () => {
    // if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftSraId=${sra.draftSraId}`,
        {
          title: sra.title,
          pr: sra.pr,
          strategy: sra.strategy,
          company: sra.company,
          category: sra.category,
          auction: sra.auction,
          plant: sra.plant,
          buyer: sra.buyer,
          singleApproval: sra.singleApproval,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Create New SRA</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">SRA Details</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Sourcing Title/Project Name
              <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra && sra.title}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="pr">
              PR/Ident No./Reference No.
              <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.pr && "input-error"}`}
              type="text"
              name="pr"
              id="pr"
              onChange={handleChange}
              value={sra && sra.pr}
            />
            {errors.pr && <p className="error">{errors.pr}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="strategy">
              Sourcing Strategy<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <select
              className={`${errors.strategy && "input-error"}`}
              name="strategy"
              id="strategy"
              onChange={handleChange}
              value={sra && sra.strategy}
            >
              <option value="">--Choose Sourcing Strategy--</option>
              {strategies &&
                strategies.map((strategy) => (
                  <option key={strategy.id} value={strategy.strategy}>
                    {strategy.strategy}
                  </option>
                ))}
            </select>
            {errors.strategy && <p className="error">{errors.strategy}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="company">
              Company Name<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.company && "input-error"}`}
              type="text"
              name="company"
              id="company"
              onChange={handleChange}
              value={sra && sra.company}
            />
            {errors.company && <p className="error">{errors.company}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="category">
              Sourcing Category<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <select
              className={`${errors.category && "input-error"}`}
              name="category"
              id="category"
              onChange={handleChange}
              value={sra && sra.category}
            >
              <option value="">--Choose Sourcing Category--</option>
              {categories &&
                categories.map((category) => (
                  <option key={category.id} value={category.category}>
                    {category.category}
                  </option>
                ))}
            </select>
            {errors.category && <p className="error">{errors.category}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="auction">
              Auction Status<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <select
              className={`${errors.auction && "input-error"}`}
              name="auction"
              id="auction"
              onChange={handleChange}
              value={sra && sra.auction}
            >
              <option value="">--Choose Auction Status--</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </select>
            {errors.auction && <p className="error">{errors.auction}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="plant">
              Plant Name<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.plant && "input-error"}`}
              type="text"
              name="plant"
              id="plant"
              onChange={handleChange}
              value={sra && sra.plant}
            />
            {errors.plant && <p className="error">{errors.plant}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="buyer">
              Creator/Buyer Name<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.buyer && "input-error"}`}
              type="text"
              name="buyer"
              id="buyer"
              onChange={handleChange}
              value={sra && sra.buyer}
            />
            {errors.buyer && <p className="error">{errors.buyer}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="singleApproval">
              Single Source Approval<span style={{ color: "#FF0000" }}>*</span>
            </label>
            <select
              className={`${errors.singleApproval && "input-error"}`}
              name="singleApproval"
              id="singleApproval"
              onChange={handleChange}
              value={sra && sra.singleApproval}
            >
              <option value="">--Choose Single Source Approval--</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </select>
            {errors.singleApproval && (
              <p className="error">{errors.singleApproval}</p>
            )}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={sra && sra.draftSraId ? handleUpdate : handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
